import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare var dataLayer: any;

@Component({
  selector: 'pq-image-results',
  templateUrl: './image.results.component.html',
  styleUrls: ['./_image.results.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageResultsComponent implements OnInit {
  @Input() public images: ImageRow[] = [];

  public query: string = '';
  public resultsUrl: string = '/results';
  public docUrl: string = '/document/';

  @Input() set profile (value: string) {
    if (value) {
      this.docUrl = '/' + value + '/document/';
      this.resultsUrl = '/' +  value + '/results';
    }
  }

  constructor(private activatedRoute: ActivatedRoute) {}

  public ngOnInit() {
    this.query = this.activatedRoute.snapshot.queryParams['query'];
  }

  public pushImageRowClickToGA(image: ImageRow) {
    if (this.images && image) {
      let imagePos = this.images.indexOf(image);
      imagePos = imagePos + 1;
      if (imagePos && dataLayer && Array.isArray(dataLayer)) {
        dataLayer.push({'event': 'ResultsImageRowClick', 'label': imagePos});
      }
    }
  }

  public pushImageRowViewAllClickToGA() {
    if (dataLayer && Array.isArray(dataLayer)) {
      dataLayer.push({'event': 'ResultsImageRowClick', 'label': 'View All'});
    }
  }
}
